import { useState, useEffect } from "react";
import "../styles/Trace.scss";
import ReactMarkdown from "react-markdown";
import { getPdfUrl } from "../api/kbAccelerator.api";
// import Modal from "../../common/Modal/Modal";
// import PdfViewer from "../chatbot/PdfViewer";

const Trace = ({ activeIndexValue, title, traceData }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  // const [titlevalue, setTitlevalue] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  let globalCounter = 0;
  const [openId, setopenId] = useState(`accordion-${globalCounter + 1}`)
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const parser = new DOMParser();
  // const [projectName, setprojectName] = useState("");

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  // const openModal = () => setIsModalOpen(true);
  // const closeModal = () => setIsModalOpen(false);

  const pdfPathGen = async (pdfpath) => {
    try {
      // const title = pdfpath.split("/");
      // setTitlevalue(title[title.length - 1]);
      const response = await getPdfUrl(pdfpath);
      const apiData = response.data
      console.log("response.url", response.data);
      if (pdfpath?.toLowerCase().includes(".xlsx")) {
        window.open(apiData.url, "_blank");
      }
      else if (pdfpath?.toLowerCase().includes(".pdf")) {
        setPdfUrl(apiData.url);
        // openModal();
      }
      else {
        window.open(apiData.url, "_blank");
      }
    } catch (error) {
    } finally {
    }
  };


  // const fileDownload = (e) => {
  //   e.preventDefault();
  //   const a = document.createElement('a');
  //   a.href = selectedChatbot[0];
  //   a.download = ''; // lets the browser infer the filename
  //   a.style.display = 'none';
  //   document.body.appendChild(a);
  //   a.click();
  //   a.remove();
  // };

  // console.log(selectedChatbot)

  useEffect(() => {
    setActiveIndex(activeIndexValue)

  }, [activeIndexValue]);


  // useEffect(() => {
  //   setprojectName(traceData)

  // }, [traceData])


  const accordionToggle = (index) => {
    setopenId(index)
  }

  const parseContent = (content) => {
    return (
      <div className="rowBox">
        <ReactMarkdown>{content}</ReactMarkdown>

      </div>
    );
  };
  // function getFileName(url) {
  //   try {
  //     const u = new URL(url);
  //     const cd = u.searchParams.get('response-content-disposition');
  //     const match = cd && cd.match(/filename\*?=(?:UTF-8''|)([^;]+)/i);
  //     if (match) return decodeURIComponent(match[1].replace(/"/g, ''));
  //     return decodeURIComponent(u.pathname.split('/').pop());
  //   } catch {
  //     return url.split('?')[0].split('/').pop();
  //   }
  // }

  const convertNodesToReact = (nodes) => {
    return Array.from(nodes).map((node) => {
      if (node.nodeType === 3) {
        return node.textContent; // Text node
      }

      const children = convertNodesToReact(node.childNodes);

      switch (node.nodeName) {
        case "LI": {
          // For each LI, generate a unique ID for its content div
          globalCounter++;
          const divId = `accordion-${globalCounter}`;

          // Separate children into H6 and DIV
          const h6Node = Array.from(node.childNodes).find(
            (child) => child.nodeName === "H6"
          );
          const divNode = Array.from(node.childNodes).find(
            (child) =>
              child.nodeName === "DIV" &&
              child.className.includes("qutoteitemList")
          );

          return (
            <li key={divId}>
              {h6Node && (
                <h6
                  className={`${h6Node.className} ${openId === divId ? 'colorText1' : ''}`}
                  onClick={() => accordionToggle(divId)}
                  style={{ cursor: "pointer" }}
                >
                  {convertNodesToReact(h6Node.childNodes)}
                </h6>
              )}
              {divNode && (
                <div
                  id={divId}
                  className={divNode.className}
                  style={{ display: openId === divId ? "block" : "none" }}
                >
                  {convertNodesToReact(divNode.childNodes)}
                </div>
              )}
            </li>
          );
        }

        case "DIV":
          return (
            <div key={node.className} className={node.className}>
              {children}
            </div>
          );

        case "H5":
          return (
            <h5 key={node.className} className={node.className}>
              {children}
            </h5>
          );

        case "UL":
          return <ul key={node.className}>{children}</ul>;

        case "PRE":
          return <pre key={node.className}>{children}</pre>;
        case "CODE":
          return <code key={node.className}>{children}</code>;
        case "THINKING":
          return <p key={node.className}>{'<thinking>' + children + '</thinking>'}</p>;
        default:
          return <span key={node.className}>{children}</span>;
      }
    });
  };


  return (
    <>
      <div className="tracePanelInner">
        <h5 className="titleText">{title}</h5>
        <div className="traceList">
          <ul>
            {traceData && traceData.map((item, index) => {
              const tag2 = item?.trace?.orchestrationTrace?.modelInvocationOutput; //|| item?.trace?.orchestrationTrace?.modelInvocationInput;
              const tag3 = item?.trace?.orchestrationTrace?.rationale;

              const tag5 = item?.trace?.orchestrationTrace?.observation;

              if (tag2?.rawResponse?.content) {
                const textData = JSON.parse(tag2?.rawResponse?.content);
                if (textData?.stop_sequence === null) {
                  return (
                    <li key={index}>
                      <span
                        className="accTitle"
                        onClick={() => handleToggle(index)}
                      >
                        Thought Process
                      </span>
                      {activeIndex === index && (
                        <>
                          {textData?.content.map((sub, ii) => {
                            if (sub?.text) {
                              return (
                                <div key={ii}>
                                  {parseContent(sub?.text)}
                                </div>
                              );
                            }
                          })}
                        </>
                      )}
                    </li>
                  );
                }
              }
              if (tag3?.text) {
                return (
                  <li key={index}>
                    <span
                      className="accTitle"
                      onClick={() => handleToggle(index)}
                    >
                      Indicative Actions
                    </span>
                    {activeIndex === index && (
                      <>
                        <p>{tag3?.text}</p>
                      </>
                    )}
                  </li>
                );
              }
              if (tag5?.knowledgeBaseLookupOutput) {
                // console.log(tag2,tag3,tag5,index,"F01")
                return (
                  <li key={index}>
                    <div className="urlList">
                      <div className="sourcesList">
                        <span
                          className="accTitle colorText1"
                          onClick={() => handleToggle(index)}
                        >
                          {" "}
                          Most Relevant Evidences
                        </span>
                        {activeIndex === index && (
                          <>
                            <div className="qutoteitemList">
                              {tag5?.knowledgeBaseLookupOutput?.retrievedReferences.map(
                                (sub, ii) => {

                                  return (
                                    <div key={ii} className="qutoteitem ">
                                      {sub?.content && (
                                        <p className="textWrap">
                                          {sub?.content?.text}
                                        </p>
                                      )}
                                      <div
                                        className="linkItem"
                                        onClick={() => {
                                          pdfPathGen(
                                            sub?.location?.s3Location?.uri
                                          );
                                        }}
                                      >
                                        {sub?.location && (
                                          <>
                                            {/* {sub?.location?.s3Location?.uri} */}
                                            {parseContent(sub?.location?.s3Location?.uri)}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>

      {/* <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div>
          <div className="popupTitleBlock mb-3">
            <h4>{titlevalue.split("/")}</h4>
          </div>
          <div className="pdfViewerblock">
            <PdfViewer pdfUrl={pdfUrl} />
          </div>
        </div>
      </Modal> */}
    </>
  );
};

export default Trace;
